import React, { FC } from "react";

import CreditCardConnector from "./components/CreditCardConnector";
import HubspotConnector from "./components/HubspotConnector";
import classes from "./AdvertiserDetailsSection.module.scss";
import { AdvertiserType } from "../../../types/advertiserTypes";

type AdvertiserExtraDetailsProps = {
  advertiser: AdvertiserType;
  fetchAndSetAdvertiserDetailData: () => void;
};

const AdvertiserExtraDetails: FC<AdvertiserExtraDetailsProps> = ({ advertiser, fetchAndSetAdvertiserDetailData }) => {
  return (
    <div className={classes.advertiserExtraDetails}>
      <HubspotConnector advertiser={advertiser} fetchAndSetAdvertiserDetailData={fetchAndSetAdvertiserDetailData} />
      <CreditCardConnector advertiser={advertiser} fetchAndSetAdvertiserDetailData={fetchAndSetAdvertiserDetailData} />
    </div>
  );
};

export default AdvertiserExtraDetails;
